export default {
    state: {
        // marcas existentes
        marcas: {},

        // vehículo seleccionado
        vehiculoSeleccionado: JSON.parse(localStorage.getItem('vehiculoSeleccionado')) || null,

        // garage operativo (solo cuando el usuario está logueado)
        garageOperativo: JSON.parse(localStorage.getItem('garage_operativo')) || null,
        garageGuest: JSON.parse(localStorage.getItem('mi_garage')) || []
    },

    getters: {
        marcas(state) {
            return state.marcas;
        },

        vehiculoSeleccionado(state) {
            // Si Vuex ya tiene el valor, usarlo
            if (state.vehiculoSeleccionado) return state.vehiculoSeleccionado;

            // Si no, intentar cargarlo desde localStorage
            const saved = localStorage.getItem('vehiculoSeleccionado');
            if (saved) {
                try {
                    const vehiculo = JSON.parse(saved);
                    state.vehiculoSeleccionado = vehiculo;
                    return vehiculo;
                } catch (e) {
                    console.error('Error parseando vehiculoSeleccionado desde localStorage', e);
                }
            }

            return null;
        },

        garageOperativo(state) {
            if (state.garageOperativo) return state.garageOperativo;

            const saved = localStorage.getItem('garage_operativo');
            if (saved) {
                try {
                    const garage = JSON.parse(saved);
                    state.garageOperativo = garage;
                    return garage;
                } catch (e) {
                    console.error('Error parseando garage_operativo desde localStorage', e);
                }
            }

            return null;
        },
        garageActivo(state) {

            if (state.garageOperativo?.vehicles?.length) {
                return state.garageOperativo.vehicles;
            }
            // Invitado
            return state.garageGuest;

        }
    },

    mutations: {
        set_marca(state, data) {
            state.marcas = data;
        },

        set_vehiculoSeleccionado(state, vehiculo) {
            state.vehiculoSeleccionado = vehiculo;
        },

        setGarageOperativo(state, garage) {
            state.garageOperativo = garage;
        },

        clear_garageOperativo(state) {
            state.garageOperativo = null;
            state.vehiculoSeleccionado = null;
        },
        setGarageGuest(state, garage) {
            state.garageGuest = garage;
        },
        clearGarageGuest(state) {
            state.garageGuest = [];
        }
    },

    actions: {
        getMarca(context) {
            axios.get('/api/getMarca').then((response) => {
                context.commit('set_marca', response.data);
            });
        },

        storeMarca(context, marcaData) {
            marcaData.post('/api/storeMarca').then(() => {
                context.dispatch('getMarca');
                $('#modalmarcas').modal('hide');
            });
        },

        updateMarca(context, marcaData) {
            marcaData.post('/api/updateMarca/' + marcaData.id).then(() => {
                context.dispatch('getMarca');
                $('#modalmarcas').modal('hide');
            });
        },

        deleteMarca(context, marcaData) {
            if (confirm('Esta seguro que desea eliminar la Marca?')) {
                axios.post('/api/deleteMarca/' + marcaData.id).then(() => {
                    context.dispatch('getMarca');
                });
            }
        },

        // Setear vehículo seleccionado
        setVehiculoSeleccionado(context, vehiculo) {
            context.commit('set_vehiculoSeleccionado', vehiculo);
            localStorage.setItem('vehiculoSeleccionado', JSON.stringify(vehiculo));
        },

        // Setear garage operativo (LOGIN)
        setGarageOperativo({ commit, dispatch }, garage) {
            const vehicles = garage.vehicles || [];
            const defaultVehicle = vehicles.find(v => v.is_default === true) || null;
            console.log(defaultVehicle);
            const garageOperativo = {
                garageId: garage.id,
                garageAlias: garage.alias,
                vehicles: vehicles,
                defaultVehicleId: defaultVehicle ? defaultVehicle.id : null,
                syncedAt: Date.now()
            };

            commit('setGarageOperativo', garageOperativo);
            localStorage.setItem('garage_operativo', JSON.stringify(garageOperativo));

            if (defaultVehicle) {
                dispatch('setVehiculoSeleccionado', {
                    //year: defaultVehicle.year,
                    marca: defaultVehicle.marca,
                   // modelo: defaultVehicle.modelo,
                    //motor: defaultVehicle.motor,
                    //linea: defaultVehicle.linea_id
                });
            }
        },

        // Limpieza total (LOGOUT)
        clearGarageOperativo({ commit }) {
            commit('clear_garageOperativo');
            localStorage.removeItem('garage_operativo');
            localStorage.removeItem('vehiculoSeleccionado');
        },
        agregarVehiculoGarage({ state, commit, dispatch }, vehiculo) {
            let garage = [...state.garageGuest];

            const exists = garage.find(g =>
                //g.year === vehiculo.year &&
                g.marca === vehiculo.marca
                //g.modelo === vehiculo.modelo &&
                //g.motor === vehiculo.motor &&
                //g.linea === vehiculo.linea
            );

            if (!exists) {
                if (garage.length >= 3) garage.shift();
                const isDefault = garage.length === 0;
                garage.push({ id: Date.now() + Math.random().toString(36).slice(2, 6), ...vehiculo, is_default: isDefault });

                localStorage.setItem('mi_garage', JSON.stringify(garage));
                commit('setGarageGuest', garage);

                if (isDefault) {
                    dispatch('setVehiculoSeleccionado', vehiculo);
                }
            }
        },
        clearGarageGuest({ commit }) {
            commit('clearGarageGuest');
            localStorage.removeItem('mi_garage');
        },
        eliminarVehiculo({ state, commit, dispatch }, vehiculo) {

            // =========
            // USUARIO LOGUEADO
            // =========
            if (state.garageOperativo) {
                axios.post('/miGarageAdmin/remove-vehicle', {
                    garage_id: state.garageOperativo.garageId,
                    vehicle_id: vehiculo.id
                }).then(res => {

                    const garage = res.data.garage;

                    commit('setGarageOperativo', garage);
                    localStorage.setItem('garage_operativo', JSON.stringify(garage));

                    dispatch('resolverVehiculoSeleccionado', garage.vehicles);
                });

                return;
            }

            // =========
            // USUARIO GUEST
            // =========
            let garage = state.garageGuest.filter(g =>
                !(
                    //g.year === vehiculo.year &&
                    g.marca === vehiculo.marca
                    //g.modelo === vehiculo.modelo &&
                    //g.motor === vehiculo.motor &&
                    //g.linea === vehiculo.linea
                )
            );

            if (vehiculo.is_default && garage.length) {
                garage = garage.map((v, index) => ({
                    ...v,
                    is_default: index === 0
                }));
            }

            commit('setGarageGuest', garage);
            localStorage.setItem('mi_garage', JSON.stringify(garage));

            dispatch('resolverVehiculoSeleccionado', garage);
        },

        // =========
        // Resolver vehículo seleccionado
        // =========
        resolverVehiculoSeleccionado({ state, dispatch }, vehicles) {
            if (!vehicles.length) {
                dispatch('setVehiculoSeleccionado', null);
                localStorage.removeItem('vehiculoSeleccionado');
                return;
            }

            const defaultVehicle = vehicles.find(v => v.is_default);

            if (defaultVehicle) {
                dispatch('setVehiculoSeleccionado', {
                    //year: defaultVehicle.year,
                    marca: defaultVehicle.marca,
                    //modelo: defaultVehicle.modelo,
                    //motor: defaultVehicle.motor,
                    //linea: defaultVehicle.linea || defaultVehicle.linea_id
                });
            }
        }
    },
};